// AUTO-GENERATED from `oak_small.json` — do not edit by hand. Regenerate via the preset
//   → `.ts` conversion script when the upstream preset JSONs change.
import type {DeepPartial, TreeOptions} from "../options.js";

const options: DeepPartial<TreeOptions> = {
    "seed": 30895,
    "type": "deciduous",
    "bark": {
      "type": "Bark001",
      "tint": 16774097,
      "flatShading": false,
      "textured": true,
      "textureScale": {
        "x": 1,
        "y": 10
      }
    },
    "branch": {
      "levels": 3,
      "angle": {
        "1": 54,
        "2": 58,
        "3": 32
      },
      "children": {
        "0": 4,
        "1": 2,
        "2": 3
      },
      "force": {
        "direction": {
          "x": 0,
          "y": 1,
          "z": 0
        },
        "strength": 0.01
      },
      "gnarliness": {
        "0": 0.07,
        "1": -0.08,
        "2": 0.11,
        "3": 0.09
      },
      "length": {
        "0": 28.08,
        "1": 4.55,
        "2": 9.78,
        "3": 7.16
      },
      "radius": {
        "0": 1,
        "1": 1.02,
        "2": 0.69,
        "3": 1.19
      },
      "sections": {
        "0": 16,
        "1": 9,
        "2": 8,
        "3": 1
      },
      "segments": {
        "0": 7,
        "1": 5,
        "2": 3,
        "3": 3
      },
      "start": {
        "1": 0.49,
        "2": 0.06,
        "3": 0.12
      },
      "taper": {
        "0": 0.73,
        "1": 0.42,
        "2": 0.69,
        "3": 0.75
      },
      "twist": {
        "0": -0.23,
        "1": 0.42,
        "2": 0,
        "3": 0
      }
    },
    "leaves": {
      "type": "oak",
      "billboard": "double",
      "angle": 42,
      "count": 14,
      "start": 0.16,
      "size": 1.38,
      "sizeVariance": 0.7,
      "tint": 14013901,
      "alphaTest": 0.5
    },
    "trellis": {
      "enabled": false
    }
  };

export default options;
